import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';
import { EventType } from '@azure/msal-browser';
import { useTranslation } from 'react-i18next';
import Snackbar from '@mui/material/Snackbar';
import AuthContext from '../../auth/AuthContext';
import { setAdviserAtFirmLocationId } from '../../features/UserSlice';
import { ADVISER_COOKIE_NAME, ADVISER_QUERY_PARAM } from '../../constants/user';

/**
 * Check to see if there's an adviserId in the url query params
 * Then set the state with the adviser id so we can use it
 * for searching under that adviser id.
 *
 */
const AdviserFirmLocation = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const msalInstance = useContext(AuthContext);
  const [cookies, setCookie, removeCookie] = useCookies([ADVISER_COOKIE_NAME]);
  const [open, setOpen] = useState(false);
  const adviserAtFirmLocationId = useSelector(
    (state) => state.user.adviserAtFirmLocationId
  );

  const setAdviser = (adviserId) => {
    dispatch(setAdviserAtFirmLocationId(adviserId));
    setOpen(true);
  };

  useEffect(() => {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const queryParams = Object.fromEntries(urlSearchParams.entries());
      // If there's an adviser id in the query param set the state and create a cookie
      if (queryParams[ADVISER_QUERY_PARAM]) {
        setCookie(ADVISER_COOKIE_NAME, queryParams[ADVISER_QUERY_PARAM], {
          path: '/',
          secure: true,
        });
        setAdviser(queryParams[ADVISER_QUERY_PARAM]);
        // If there's a cookie then set the state with the adviser id cookie value
      } else if (cookies[ADVISER_COOKIE_NAME]) {
        setAdviser(cookies[ADVISER_COOKIE_NAME]);
      }
    } catch {
      //
    }
  }, []);

  useEffect(() => {
    // Remove adviser cookie on logout
    msalInstance.addEventCallback(
      async (event) => {
        if (event.eventType === EventType.LOGOUT_START) {
          removeCookie(ADVISER_COOKIE_NAME);
        }
      },
      (error) => {
        console.log('Auth logout error', error);
      }
    );
  }, []);

  if (adviserAtFirmLocationId) {
    return (
      <Snackbar
        open={open}
        autoHideDuration={6000}
        message={`${t(
          'adviserFirmLocationSnackbar.label'
        )} ${adviserAtFirmLocationId}`}
        onClose={() => setOpen(false)}
      />
    );
  }

  return null;
};

export default AdviserFirmLocation;
